var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_vm._v("\n            +1\n        ")])],1),_c('b-input',{attrs:{"value":_vm.value,"disabled":_vm.disabled,"placeholder":"(---) --- ----"},on:{"input":_vm.emitInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }